"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("../Util/Button"));
const SelectContext_1 = require("../../contexts/SelectContext");
const SelectButtonCaret_1 = __importDefault(require("./SelectButtonCaret"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const PopoverContext_1 = __importDefault(require("../../contexts/PopoverContext"));
const SelectButton = (props) => {
    const { children, label, placeholder } = props;
    const buttonRef = react_1.useRef(null);
    const { value, isOpen, setOpen, clickedAwayAt } = react_1.useContext(SelectContext_1.SelectContext);
    const { inPopover } = react_1.useContext(PopoverContext_1.default);
    const onClick = react_1.useCallback((e) => {
        const clickedAwayRecently = clickedAwayAt.current > (Date.now() - 500);
        if (clickedAwayRecently) {
            // fixes clicking on the button that triggers the dropdown not closing the dropdown
            // as it would trigger twice and cause the dropdown to reopen.
            return;
        }
        if (isOpen && inPopover) {
            // Dont do anything if we are using a dropdown because our clickaway action will take care of dismissing us.
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        setOpen(!isOpen, buttonRef.current);
    }, [clickedAwayAt, inPopover, isOpen, setOpen]);
    let placeholderHandle = placeholder;
    if (!label && !placeholder) {
        placeholderHandle = 'Select an option';
    }
    const className = classnames_1.default(props.className, { open: isOpen });
    return (react_1.default.createElement(Button_1.default, Object.assign({}, props, { ref: buttonRef, onClick: onClick, className: className }), children ? react_1.default.createElement(react_1.default.Fragment, null, children) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", null,
            label,
            label && value && ': ', value !== null && value !== void 0 ? value : placeholderHandle),
        react_1.default.createElement(SelectButtonCaret_1.default, null)))));
};
exports.default = withJourney_1.default('j-select-button', SelectButton, { wrapsHref: false });
